module.exports = __webpack_public_path__ + "img/Baseball.266ff56a.png";